import cx from "classnames";
import { styled } from "@linaria/react";
import React from "react";
import SidePanelLayout from "@ui/SidePanel/Layout";
import { DashboardLite } from "../../Dashboards/view/Dashboard/Lite";
import { css } from "@linaria/core";
import { useOutletContext, useParams } from "react-router";
import type { Project } from "../../../../api/useProjects";

const SynthesisDashboardLite = () => {
  const project = useOutletContext<Project>();
  if (!project) throw new Error("no project");
  const { dashboardId } = useParams();
  if (!dashboardId) throw new Error("no dashboards");

  return (
    <SidePanelLayoutNoFlex>
      <DashboardLite
        projectId={project.id}
        className={cx(dashboardLite, "lite")}
        withHeader={false}
        dashboardId={dashboardId}
      />
    </SidePanelLayoutNoFlex>
  );
};
export default SynthesisDashboardLite;

//#region CSS
const SidePanelLayoutNoFlex = styled(SidePanelLayout)`
  flex: none;
  gap: 0;
`;
const dashboardLite = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding-bottom: 0;
`;
//endregion CSS
